<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"FACILITATOR.dshabilit" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"FACILITATOR.disabled-text-modal" | translate}}
  </p>
  <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"FACILITATOR.disabled-text-two" |
    translate}}</small>


  <div class="btn-proceed alt-flex-end">
    <button class="btn-cancel alt-color-bran1 pointer alt-inter-medium alt-size-14" type="button"
      [mat-dialog-close]="false">{{"USERS.go-back" | translate | uppercase }}</button>
    <button class="btn-agree alt-color-bran1 pointer alt-inter-medium alt-size-14 " type="button"
      [mat-dialog-close]="true">{{"USERS.agree-disabled" | translate | uppercase
      }}</button>
  </div>
</div>
